import httpService from "./HttpService";

export async function createUser(userData) {
  return httpService.post(`onboarding`, userData, null);
}
